import {lazyRegister} from '@/Core/lazyRegister';
import './checkbox-switch.component.css';
import template from './checkbox-switch.component.html';

class CheckboxSwitchController {
    static $inject = ['$element'];
    onChange: (args: { $event: boolean | number }) => void;
    onClick: () => void;
    ngModel: ng.INgModelController;
    ngValue?: string;
    valueType?: 'number';
    checked: boolean;

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('checkbox-switch');
        this.ngModel.$render = () => {
            this.checked = this.valueType === 'number'
                ? this.ngModel.$viewValue === 1
                : !!this.ngModel.$viewValue;
        };
    }

    handleChange() {
        const value = this.valueType === 'number' ? Number(this.checked) : this.checked;
        this.ngModel.$setViewValue(value);

        if (this.onChange) {
            this.onChange({$event: value})
        }
    }

    handleClick() {
        if (this.onClick) {
            this.onClick()
        }
    }
}

export const CheckboxSwitchComponent: ng.IComponentOptions = {
    transclude: true,
    require: {
        ngModel: 'ngModel'
    },
    bindings: {
        ngValue: '<?',
        valueType: '@?',
        ngDisabled: '<?',
        onChange: '&?',
        onClick: '&?'
    },
    template: template,
    controller: CheckboxSwitchController
};

lazyRegister.component('checkboxSwitch', CheckboxSwitchComponent);
